import {LocationType} from '../../../../gql/customer/graphql.ts';
import modalStyles from '../../../../components/modal/modal.module.scss';
import {List} from '../../../../components/list/list.tsx';
import React, {useCallback} from 'react';
import {useClickOutside} from '../../../../support/use_click_outside.ts';
import {__} from '../../../../support/lang/translations.ts';
import {LocationSelectListItem} from '../../../../components/location/location_select_list_item.tsx';

interface OwnProps {
    onCloseModal: () => void;
    locations?: (LocationType | null)[] | null;
    locationId: number | null;
    onLocationIdChange: (locationId: number) => void;
}

export function SelectLocationModal(props: OwnProps) {
    const ref = React.useRef<HTMLDivElement | null>(null);
    const {onCloseModal} = props;
    const closeModalCallback = useCallback(() => {
        onCloseModal();
    }, [onCloseModal]);
    useClickOutside(ref, closeModalCallback);

    const onLocationSelect = (locationId: number | null) => {
        if (locationId) {
            props.onLocationIdChange(locationId);
            onCloseModal();
        }
    };

    return (
        <div className={modalStyles.modal_backdrop}>
            <div className={modalStyles.modal}>
                <div className={modalStyles.modal_dialog} ref={ref}>
                    <div className={modalStyles.modal_header}>
                        <span />
                        <h2>{__('appointment.location_select.modals.titles.select')}</h2>
                        <button type="button" onClick={() => onCloseModal()}>
                            <i className="fa-light fa-close"></i>
                        </button>
                    </div>
                    <div className={modalStyles.modal_body}>
                        <List>
                            {props.locations?.map(
                                (location) =>
                                    location?.id != null && (
                                        <LocationSelectListItem
                                            key={location.id}
                                            selectedLocationId={props.locationId}
                                            location={location}
                                            onClick={onLocationSelect}
                                        />
                                    ),
                            )}
                        </List>
                    </div>
                </div>
            </div>
        </div>
    );
}
